import leoProfanity from "leo-profanity";
import * as nsfwjs from "nsfwjs";
import { czechBadWords, slovakBadWords } from "../constants/badWords";

leoProfanity.loadDictionary("en");
let nsfwModel: nsfwjs.NSFWJS | null = null;

export const loadNSFWModel = async () => {
  nsfwModel ??= await nsfwjs.load("../models/mobilenet_v2/model.json");
  return nsfwModel;
};

export const checkNSFW = async (file: File | string): Promise<boolean> => {
  const model = await loadNSFWModel();
  let img: HTMLImageElement;

  if (typeof file === "string") {
    img = new Image();
    img.src = file;
    await new Promise((res) => (img.onload = res));
  } else {
    img = new Image();
    img.src = URL.createObjectURL(file);
    await new Promise((res) => (img.onload = res));
  }

  const predictions = await model.classify(img);

  const nsfwProb = predictions
    .filter((p) => ["Porn", "Hentai", "Sexy"].includes(p.className))
    .reduce((acc, p) => acc + p.probability, 0);

  return nsfwProb > 0.7;
};

function normalize(text: string) {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replaceAll(/[\u0300-\u036f]/g, "");
}

export function containsExplicitWords(text: string): {
  found: boolean;
  word: string | null;
} {
  const allBadWords = [...czechBadWords, ...slovakBadWords];
  const badRoots = allBadWords.map(normalize);
  const normalizedText = normalize(text);
  const words = normalizedText.split(/\s+/);

  for (const word of words) {
    const foundWord = badRoots.find((root) => word.includes(root));
    if (foundWord) return { found: true, word };

    if (leoProfanity.check(word)) return { found: true, word };
  }

  return { found: false, word: null };
}
